<template>
  <button type="button" :class="btnClass" @click="showOfficeModal">
    <FileEarmarkPlusIcon />
    {{ i18n('Add New') }}
  </button>

  <OfficeModal ref="OfficeModal" @created="$emit('created', $event)" :company="company" />
</template>
<script>
import OfficeModal from "@/components/office/OfficeModal.vue";
import FileEarmarkPlusIcon from "@/assets/svg/file-earmark-plus.vue";

export default {
  components: {
    OfficeModal,
    FileEarmarkPlusIcon,
  },
  props: {
    company: {
      type: Object,
    },
    btnClass: {
      type: String,
      default: 'btn btn-outline-light',
    },
  },
  data() {
    return {
      formData: {},
    };
  },
  emits: [
    'added',
    'created'
  ],
  methods: {
    showOfficeModal() {
      this.$refs['OfficeModal'].show();
    },
  }
};
</script>